/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stat_DoneInputs */

const en_dashboard_stat_done = /** @type {(inputs: Dashboard_Stat_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const pt_br2_dashboard_stat_done = /** @type {(inputs: Dashboard_Stat_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Dashboard_Stat_DoneInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_stat_done = /** @type {((inputs?: Dashboard_Stat_DoneInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stat_DoneInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_stat_done(inputs)
	return pt_br2_dashboard_stat_done(inputs)
});